<template>
  <div class="scrollView Gongyi">






      <div class="gongyibanner2" v-if="data">
          <img :src="data.img" >
      </div>

      <h1 class="title">{{data.title}}</h1>


<!--      <div class="aixin-info">-->
<!--          <div class="aixin-info-item">-->
<!--              <div>公益援助已开启</div>-->
<!--              <span>{{data.day}}天</span>-->
<!--          </div>-->
<!--          <div class="line"></div>-->
<!--          <div class="aixin-info-item">-->
<!--              <div>爱心援助(元)</div>-->
<!--              <span>{{data.money_count}}</span>-->
<!--          </div>-->
<!--          <div class="line"></div>-->
<!--          <div class="aixin-info-item">-->
<!--              <div>捐款次数</div>-->
<!--              <span>{{data.donate_count}}</span>-->
<!--          </div>-->
<!--      </div>-->

      <div class="Title">
          <div>受助人的故事</div>
      </div>
      <div v-if="data.onlive_url" class="live">
          <video :src="data.onlive_url" controls webkit-playsinline="true" x5-playsinline="true" playsinline="true"  x-webkit-airplay="true" autoplay :poster="data.onlive_img"></video>
      </div>
      <div class="content1-Containner">
          <div :style="{height:!showMore?contentHeight+'px':'auto'}" class="contant-containner">
              <div class="content" id="hidecontent"  v-html="data.introduce">


              </div>
          </div>

          <div class="showMore" @click="setMore()">
              {{showMore?'收起更多':'查看更多'}}
          </div>



      </div>


      <div class="Title" v-if="data.content">
          <div>公益产品介绍</div>
      </div>

      <div class="content"   v-html="data.content"  v-if="data.content"></div>





        <div class="DounloadBtn_c">
            <div class="DounloadBtn" @click="Download()">
                下载看度时政APP帮助TA
            </div>
        </div>

  </div>
</template>


<style>
    .Gongyi.scrollView{padding-bottom: 60px}
    .DounloadBtn_c{
        position: absolute;
        left: 0; right: 0; bottom:0; background-color: #fff;height: 60px; width: 100%; padding: 0 15px;
         display: flex;; align-items: center;
    }
    .DounloadBtn{
        width: 100%;
        background-image:linear-gradient( 90deg, rgb(203,7,17) 0%, rgb(254,158,33) 100%);
        background-image: -webkit-linear-gradient( 90deg, rgb(203,7,17) 0%, rgb(254,158,33) 100%);
        height: 40px; border-radius: 40px; display: flex;; justify-content: center;; align-items: center; font-size: 14px; color: #fff;
    }

    .title{ padding: 20px 15px; font-size: 16px; line-height: 1.4}
    .gongyibanner2{ width: 100%;}
    .gongyibanner2 img{ width: 100%; display: block}

    .bottomBar{ height: 50px; display: flex;justify-content: space-between;align-items: center;border-top: 0.5px solid rgba(0,0,0,0.1);}
    .bottomBar-btn1{width: 26%; display: flex; justify-content: center; align-items: center; flex-direction: column; font-size: 12px; color: #848484;
        height: 50px;
    }
    .bottomBar-btn1 img{ height: 20px; margin-bottom:3px;}
    .bottomBar-btn2{width: 40%;height: 50px;  font-size: 20px; color: #fff; text-align: center; display: flex; justify-content: center; align-items: center;
        background-image: -webkit-linear-gradient( 90deg, rgb(203,7,17) 0%, rgb(254,158,33) 100%);
    }




    .aixin-info{ display: flex; justify-content: space-between; align-items: center;background-color: #f4f4f4; padding: 15px; border-radius: 6px; font-size: 12px; color: #8f8f8f;
        margin: 0 15px}
    .aixin-info-item{ width: 30%; text-align: center}
    .aixin-info-item div{ margin-bottom: 8px}
    .aixin-info-item span{ font-size: 18px; color: #e9424a}
    .line{ width: 0.5px; height: 30px; background-color: #e2e2e2}

    .Title{ font-size: 20px; font-weight: bold; color: #3b4140; display: flex; align-items: center; height:30px; margin:22px 15px;
        border-left: 5px solid #f6b545}
    .Title div{ padding-left: 5px}

    .content{line-height: 1.5; padding: 15px; text-align: justify; font-size: 16px; padding-top: 0}
    .content img{ max-width: 100%; object-fit: contain }
    .content video,.content div,.content p,.content span,.content table{ max-width: 100%}

    .showMore{ background-image: -webkit-linear-gradient( -90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%);
        width: 100%; display: flex;justify-content: center;align-items: center;
        padding-top: 40px; position: relative;top: -50px; line-height: 40px; color: #fe9e21;
    }

    .hideMore{ height: 200px; overflow: hidden}
    .zhizhu ,.zhizhu img{ width: 100%; height: 100px}
    .zhizhu{ padding:5px; position: relative; }
    .zhizhu-content{ position: absolute; right: 30px; bottom:20px; width: 120px; height: 50px;background-color: #fff; border-radius: 4px;
        overflow: hidden;-webkit-overflow-scrolling:auto;box-shadow:  inset 0px 0px 6px rgba(0,0,0,0.2), 0 0 1px #fff}
    .contant-containner{ overflow: hidden}

    .content span,.content strong,.content a{ display: inline !important;}
    .content video{ display: block}
    .live{ padding: 15px}
    .live video{ display: block; width: 100%}
</style>
<script>
  import config from "../config";
  import {Toast} from "vant";
  var $ = require("jquery");
  import utils from '../utils'
  import request from '../utils/request'
  export default {
    name: 'Gongyi',

    data() {
      return {
          data:{},
        id: this.$route.params.id,
          list:[],
          page:1,
          showMore:true,//显示更多
          winHeight:window.innerHeight - 50 - 60,
          contentHeight:200,//故事高度
      }
    },
    created() {
      console.log(this.$route.params.id);
      this.getContent();
      window.onresize = ()=>{
          this.winHeight = window.innerHeight - 50 - 60
      }

    },

      methods: {
        setMore(){
            this.showMore = !this.showMore
        },
        Download(){
            let url = 'shenniao://app?code={"module":"gongyi","id":'+this.$route.params.id+'}';
            setTimeout(()=>{
                location.href = 'http://img2.yitoutiao.net/app/download.html';
            },500)
            location.href = url;

        },
      getContent() {
        $.get(config.SHOP2 + '/v616.lucky/info?good_id=' + this.$route.params.id, (res) => {
          if (res && res.code==200) {

              try{
                  res.data.content = res.data.content.replace(/<video [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                      var reg = /<video[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                      var url = '';
                      while (reg.exec(match)) {
                          url = RegExp.$1;
                      }
                      if (url) {
                          return '<video controls webkit-playsinline="true" x5-playsinline="true" playsinline="true"  x-webkit-airplay="true" src="' + url + '" poster="' + url + '?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast" >';
                      }
                      return '';
                  });
                  res.data.introduce = res.data.introduce.replace(/<video [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                      var reg = /<video[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                      var url = '';
                      while (reg.exec(match)) {
                          url = RegExp.$1;
                      }
                      if (url) {
                          return '<video controls webkit-playsinline="true" x5-playsinline="true" playsinline="true"  x-webkit-airplay="true" src="' + url + '" poster="' + url + '?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast" >';
                      }
                      return '';
                  });
              }catch (e) {
              }

            this.data = res.data;
              setTimeout(()=>{
                if(document.getElementById("hidecontent").offsetHeight < 200){
                    this.contentHeight = document.getElementById("hidecontent").offsetHeight;
                    document.getElementsByClassName("showMore")[0].style.display = 'none'
                }
              },300)
              request.getWeixinShanre(location.href,(s_res)=>{
                  console.log(s_res);
                  if(utils.is_weixin()){
                      if(res.data.title){

                          let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                          let shareconfig = {appId,timestamp,nonceStr,signature};

                          let sharedata = {
                              title:res.data.title,
                              desc:res.data.introduce,
                              link:location.href,
                              imgUrl:this.data.img+'?x-oss-process=image/resize,m_lfit,h_300,w_300'
                          };
                          utils.setWeiXinShare(sharedata,shareconfig)
                      }

                  }
              });


          }else if(res.message){
            Toast(res.message);
          }

        }, 'JSON')
      },

    }
  }
</script>
